import { TranslateModule } from '@ngx-translate/core';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { KeySearchResultsListModule } from '../../search-results-list/search-results-list.module';
import { KeyFormBuilderModule } from '../../form-builder/form-builder.module';
import { KuiModule } from 'app/key-ui';
import { LocationSelectModalComponent } from './location-select-modal.component';
import { KeyMapModule } from '../../map/map.module';
import { DecimalDegreesToDegreesPipe } from 'app/shared/pipes';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        KuiModule,
        TranslateModule.forChild(),
        KeySearchResultsListModule,
        KeyFormBuilderModule,
        KeyMapModule,
    ],
    exports: [
        LocationSelectModalComponent,
    ],
    declarations: [
        LocationSelectModalComponent,
    ],
    providers: [
        DecimalDegreesToDegreesPipe,
    ]
})
export class LocationSelectModalModule { }
